<template>
  <b-row>
    <b-col>
      <CCard>
        <CCardHeader> <strong>搜尋條件</strong> </CCardHeader>
        <CCardBody>
          <b-row>
            <b-col lg="2" md="3">
              <b-form-group label="案件階段">
                <b-form-select v-model="filter.phase" :options="filterphaselist"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="工單編號">
                <b-form-input v-model="filter.no"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="客戶編號或名稱">
                <b-form-input v-model="filter.customer"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="起始日期">
                <date-picker v-model="filter.start" valueType="format" />
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="結束日期">
                <date-picker v-model="filter.end" valueType="format" />
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="顯示模式">
                <b-form-checkbox v-model="filter.pagination" value="false" unchecked-value="true">全頁顯示</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </CCardBody>
        <CCardFooter class="text-right">
          <CButton type="submit" size="sm" color="success" class="mr-1" @click="search()">查詢</CButton>
          <CButton type="reset" size="sm" color="danger" @click="clearFilter()">清空</CButton>
        </CCardFooter>
      </CCard>

      <CCard>
        <CCardHeader> <strong>收件列表</strong> </CCardHeader>
        <CCardBody>
          <div class="my-2 d-flex justify-content-between">
            <div>
              <a href="#" @click="fieldsetting.show = true" class="link-primary">設定顯示欄位</a>
            </div>
            <div>
              <span class="text-primary">總計 {{ pageinfo.count }} 筆資料，共 {{ pageinfo.totalPage }} 頁，目前顯示第 {{ pageinfo.page
                }} 頁</span>
            </div>
          </div>
          <b-table class="case-table" sticky-header hover bordered responsive :items="datalist" :fields="fieldresult"
            :tbody-tr-class="rowClass" show-empty>
            <template #empty>
              <h2 class="text-secondary text-center m-4">無資料</h2>
            </template>
            <template #cell(index)="row">{{ row.index + 1 }}</template>
            <template #cell(phase)="row"> <b-form-select :options="phaselist" :value="row.item.phase" class="w-auto"
                @change="changePhase(row.item.id, $event)"></b-form-select></template>
            <template #cell(date)="row">{{ $date(row.item.date).format("YYYY-MM-DD") }}</template>
            <template #cell(resultDate)="row">{{ row.item.resultDate ? $date(row.item.resultDate).format("YYYY-MM-DD") :
              "--" }}</template>
            <template #cell(brand)="row">{{ row.item.device }}/{{ row.item.brand }}</template>
            <template #cell(recoveryRate)="row">{{ row.item.recoveryRate ? row.item.recoveryRate + "%" : "--"
              }}</template>
            <template #cell(openHardDrive)="row">
              {{ row.item.openHardDrive === 0 ? "--" : $modules.OpenHardDrive.find((p) => p.value ===
                row.item.openHardDrive).text }}
            </template>
            <template #cell(contact)="row">{{ row.item.contactName }}<span v-if="row.item.contactName"> - </span>{{
              row.item.contactInformation }}</template>
            <template #cell(customerName)="row">
              {{ row.item.customerNo }} - {{ row.item.customerName ? row.item.customerName : row.item.contactName }}
              <span v-if="row.item.referrerNo && row.item.referrerName">({{ row.item.referrerNo }} - {{
                row.item.referrerName }})</span>
            </template>
            <template #cell(action)="row">
              <b-button variant="primary" size="sm" :to="{ name: '收件資料', params: { id: row.item.id } }">詳細資料</b-button>
            </template>
          </b-table>
          <b-pagination v-model="pageinfo.page" :total-rows="pageinfo.count" :per-page="pageinfo.limit" align="center" v-if="!loading"
            @change="changePage"></b-pagination>
        </CCardBody>
      </CCard>
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>

      <b-modal title="設定顯示的欄位" no-close-on-backdrop v-model="fieldsetting.show">
        <b-form-checkbox-group v-model="fieldsetting.showFields" :options="fieldlist" stacked></b-form-checkbox-group>
        <template #modal-footer>
          <b-button variant="primary" class="float-right" @click="saveFields()"> 儲存 </b-button>
        </template>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-tw";

export default {
  name: "CaseList",
  components: { DatePicker },
  data: () => ({
    phaselist: [],
    loading: false,
    datalist: [],
    pageinfo: {
      count: 1,
      limit: 10,
      page: 1,
      totalPage: 1,
    },
    fieldsetting: {
      showFields: [],
      show: false,
    },
    fields: [
      { key: "index", label: "序號", class: "text-center align-middle text-nowrap" },
      { key: "no", label: "工單編號", class: "text-center align-middle text-nowrap" },
      { key: "customerName", label: "客戶名稱", tdClass: "align-middle text-nowrap", thClass: "text-center align-middle" },
      { key: "phone", label: "電話", class: "text-center align-middle text-nowrap" },
      { key: "contact", label: "聯絡方式", class: "text-center align-middle text-nowrap" },
      { key: "date", label: "收件日", class: "text-center align-middle text-nowrap" },
      { key: "resultDate", label: "送貨日", class: "text-center align-middle text-nowrap" },
      { key: "phase", label: "處理階段", class: "text-center align-middle text-nowrap" },
      { key: "brand", label: "設備與廠牌", class: "text-center align-middle text-nowrap" },
      { key: "model", label: "型號", class: "text-center align-middle text-nowrap" },
      { key: "serial", label: "序號", class: "text-center align-middle text-nowrap" },
      { key: "result", label: "處理結果", class: "text-center align-middle text-nowrap" },
      { key: "resultContent", label: "處理內容", class: "text-center align-middle text-nowrap" },
      { key: "openHardDrive", label: "是否開盤", class: "text-center align-middle text-nowrap" },
      { key: "recoveryRate", label: "資料救援率", class: "text-center align-middle text-nowrap" },
      { key: "shipping", label: "出貨方式", class: "text-center align-middle text-nowrap" },
      { key: "shippingNo", label: "出貨單號", class: "text-center align-middle text-nowrap" },
      { key: "total", label: "金額", class: "text-center align-middle text-nowrap" },
      { key: "discount", label: "優惠資訊", class: "text-center align-middle text-nowrap" },
      { key: "remark", label: "備註", class: "text-center align-middle text-nowrap" },
      { key: "action", label: "操作", class: "text-center align-middle text-nowrap" },
    ],
    filter: {
      phase: null,
      customer: "",
      no: "",
      start: "",
      end: "",
      pagination: true
    },
    filterphaselist: [],
  }),
  mounted() {
    const { page, phase, customer, no, start, end, pagination } = this.$route.query;
    this.pageinfo.page = page || 1;
    this.filter.phase = phase || null;
    this.filter.customer = customer || "";
    this.filter.no = no || "";
    this.filter.start = start || "";
    this.filter.end = end || "";
    this.filter.pagination = pagination === "false" ? false : true;
    this.getFields();
    this.getPhaselist();
    this.getCases();
  },
  computed: {
    fieldresult() {
      let keys = ["index", "no", "action", ...this.fieldsetting.showFields];
      return this.fields.filter((p) => keys.includes(p.key));
    },
    fieldlist() {
      return this.fields
        .filter((p) => p.key != "index" && p.key != "no")
        .map((item) => {
          return {
            text: item.label,
            value: item.key,
          };
        });
    },
  },
  methods: {
    getFields() {
      if (localStorage.getItem("casefields")) {
        this.fieldsetting.showFields = JSON.parse(localStorage.getItem("casefields"));
      }
    },
    saveFields() {
      localStorage.setItem("casefields", JSON.stringify(this.fieldsetting.showFields));
      this.fieldsetting.show = false;
    },
    changePhase(id, value) {
      let params = {
        id: id,
        phase: value,
      };
      this.$http.patch("/case/phase", params).then((response) => {
        if (response.data.success) {
          this.$notify({ type: "success", text: "編輯階段成功" });
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
      });
    },
    getPhaselist() {
      this.phaselist = this.$modules.CasePhase;
      this.filterphaselist = [{ value: null, text: "請選擇" }, ...this.$modules.CasePhase];
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.phase >= 100) return "table-secondary";
    },
    getPhase(val) {
      let type = this.$modules.CasePhase.find((p) => p.value === val);
      return type.text;
    },
    getCases() {
      this.loading = true;
      let params = {
        params: {
          page: this.pageinfo.page,
          phase: this.filter.phase,
          customer: this.filter.customer,
          no: this.filter.no,
          start: this.filter.start,
          end: this.filter.end,
          pagination: this.filter.pagination,
        },
      };
      this.$http.get("/case/list", params).then((response) => {
        if (response.data.success) {
          this.datalist = response.data.result.datalist;
          this.pageinfo = response.data.result.pageinfo;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    search(page = 1) {
      this.pageinfo.page = page
      this.$router.push({
        name: "收件總表",
        query: {
          phase: this.filter.phase,
          customer: this.filter.customer,
          no: this.filter.no,
          start: this.filter.start,
          end: this.filter.end,
          pagination: this.filter.pagination,
          page: page
        }
      });
      this.getCases();
    },
    changePage(page) {
      this.search(page)
    },
    clearFilter() {
      this.pageinfo.page = 1;
      this.filter.customer = "";
      this.filter.no = "";
      this.filter.start = "";
      this.filter.end = "";
      this.filter.closed = null;
      this.filter.pagination = true;
      this.search();
    },
  },
};
</script>
